import { DEFAULT_FOLDER_PATH } from '~/reducers/folderReducer'

import React from 'react'

import { setCurrentFolderId, setFolderPath } from '~/actions/folderActions'

import { useRecentFilesQuery } from '~/hooks/services/provide/queries/useRecentFilesQuery'

import moment from 'moment'
import { IoDocumentOutline } from 'react-icons/io5'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Tile, TileFooter, TileHeader, TileListContent, TileListItem } from '../Tile'

const RecentFilesTile: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { data } = useRecentFilesQuery(5)
  const recentFiles = data?.files ?? []

  return (
    <Tile>
      <TileHeader>
        <TileHeader.Title>{data?.totalCount ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Latest Documents</TileHeader.Subtitle>
        <TileHeader.Item>
          <IoDocumentOutline className="h-10 w-10 text-th-primary" />
        </TileHeader.Item>
      </TileHeader>
      <TileListContent limit={3} bordered>
        {recentFiles.map((file) => (
          <TileListItem key={file.id} onClick={() => navigate(`/documents?folderId=${file.folderId}`)}>
            <TileListItem.Title>{file.fileName}</TileListItem.Title>
            <TileListItem.Subtitle>Uploaded at {moment(file.createdAt).fromNow()}</TileListItem.Subtitle>
          </TileListItem>
        ))}
      </TileListContent>
      {data && data.totalCount > 0 && recentFiles.length > 3 && (
        <TileFooter
          onMouseDown={() => {
            dispatch(setFolderPath(DEFAULT_FOLDER_PATH))
            dispatch(setCurrentFolderId(null))
            navigate('/documents?view=recent')
          }}
        >
          View {data?.totalCount - 3} more...
        </TileFooter>
      )}
    </Tile>
  )
}

export default RecentFilesTile
